import { Item, Creator, CreatorImage } from "../styled";
import Link from "next/link";
import React from "react";
import { NoImage } from "styles/App.styled";
import { Icon } from "components/SvgIcons";
import cloudfront from "helpers/cloudfront";
import { getImageName } from "../../../helpers";

const CardCreatedBy = ({ elementType, handleMouseMove, handleMouseDown, handleClick }) => {
  const { slug } = elementType;

  let href = "/users/[id]";
  let as = `/users/${elementType.id}`;

  if (slug) {
    href = "/[id]";
    as = `/${slug}`;
  }

  return (
    <Link href={href} as={as} passHref>
      <a onMouseMove={handleMouseMove} onMouseDown={handleMouseDown} onClick={handleClick}>
        <Creator>
          <CreatorImage>
            {elementType.main_image ? (
              <img
                src={cloudfront({ href: elementType.main_image, size: "small" })}
                alt={getImageName(elementType.main_image)}
              />
            ) : (
              <NoImage className="buyer">
                <Icon icon="avatar" className="user" />
              </NoImage>
            )}
          </CreatorImage>
          <span>by</span>
          <Item>
            {elementType.show_business_name ? (
              elementType.business_name
            ) : (
              <>
                {elementType.first_name} {elementType.last_name}
              </>
            )}
          </Item>
        </Creator>
      </a>
    </Link>
  );
};

export default CardCreatedBy;
